import {Container} from 'src/design/atoms/Container';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';
import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

import {clearLoginRouting} from 'src/app/security/authentication/configureAmplify';
import {purgeAtLogout} from 'src/offline/sessionJanitor';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useAppDispatch} from 'src/redux/hooks';
import {resetAuthState, signOutUser} from 'src/redux/slices/authSlice';
import {resetSessionState} from 'src/redux/slices/sessionSlice';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import classes from './Logout.module.css';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const LogoutPage = () => {
  useSetDocumentTitle('Logging out...');
  const navigate = useAppNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');
  const loginUrl =
    returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
      ? `${PathUtility.Login()}?returnUrl=${encodeURIComponent(returnUrl)}`
      : PathUtility.Login();

  useEffect(() => {
    // Fire-and-forget before the dispatches clear identity — must not gate the
    // redirect timer below.
    void purgeAtLogout();

    dispatch(resetSessionState());
    dispatch(resetAuthState());
    void dispatch(signOutUser());
    clearLoginRouting();

    const timer = setTimeout(() => {
      try {
        navigate(loginUrl, {replace: true});
      } catch (error) {
        console.error(error);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container size={420} my={40}>
      <Title ta="center" className={classes.title}>
        See you next time!
      </Title>
      <Text c="dimmed" size="sm" ta="center" mt={5}>
        We are logging you out right now. Thanks for visiting! You will
        automatically be redirected when your logout is completed.
      </Text>
    </Container>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'transient',
  path: PathUtility.Logout(),
  element: <LogoutPage />,
  isPrivate: false,
});

export {LogoutPage};
